export default "__VITE_ASSET__Dy8REr$M__"